// extracted by mini-css-extract-plugin
export var dropdownButton = "_27-0";
export var fullWidthDropdownButton = "_27-1";
export var icon = "_27-3";
export var iconPlaceholder = "_27-2";
export var menuItemRow = "_27-9";
export var separator = "_27-e";
export var shortcutContainer = "_27-7";
export var shortcutContainerFilled = "_27-8";
export var shortcutIconLg = "_27-6";
export var shortcutIconMd = "_27-5";
export var shortcutIconSm = "_27-4";
export var submenuChevron = "_27-d";
export var submenuDropdown = "_27-a";
export var submenuTriggerRow = "_27-b";
export var submenuTriggerRowOpen = "_27-c";